export default (props) => (
  /**
   * Ícone ponta de seta apontada para baixo
   */
  <svg
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.74827 0.911694C9.78764 0.955847 9.81791 1.00734 9.83735 1.06321C9.85679 1.11909 9.865 1.17825 9.86153 1.23731C9.85806 1.29637 9.84296 1.35416 9.81711 1.40737C9.79126 1.46058 9.75516 1.50817 9.71088 1.5474L5.65661 5.1512C5.5742 5.22451 5.46775 5.26501 5.35745 5.26501C5.24715 5.26501 5.14069 5.22451 5.05829 5.1512L1.00402 1.5474C0.918645 1.46704 0.867966 1.35656 0.862751 1.23942C0.857536 1.12229 0.898197 1.00774 0.976093 0.920105C1.05399 0.832472 1.16298 0.778664 1.27992 0.770112C1.39686 0.76156 1.51252 0.798938 1.60234 0.874305L5.35745 4.21196L9.11256 0.874305C9.15673 0.83498 9.20823 0.804751 9.2641 0.785346C9.31997 0.76594 9.37912 0.757739 9.43816 0.761211C9.49721 0.764684 9.55498 0.779762 9.60819 0.805583C9.66141 0.831405 9.709 0.867462 9.74827 0.911694Z"
      fill="currentColor"
    />
  </svg>
);
